import SpinnerButton from '@kopapro/components/commons/spinnerButton/spinnerButton';

export default SpinnerButton;
